import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComputer } from "@fortawesome/free-solid-svg-icons";
import { faMicrosoft } from "@fortawesome/free-brands-svg-icons";
import css from "./SaveProjectWindow.module.css";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import {
	closeWindow,
	createWindow,
	WindowTypeAndPropsDefinition,
} from "../../../windowManagerSlice";
import { selectFetchLogicsStatus } from "../../../../logics/logicsSlice";
import SaveFormat from "../../../../../common/save/SaveFormat";
import { getUniqueIdMap } from "../../../../../common/generateUniqueId";
import Pako from "pako";
import Version from "../../../../../common/Version";
import { env } from "../../../../../env/env";
import { selectEditor } from "../../../../editor/editorSlice";

export interface SaveProjectWindowProps {}

export type SaveProjectWindowTypeAndProps = WindowTypeAndPropsDefinition<
	"saveProject",
	SaveProjectWindowProps
>;

export const saveVersion: Version = {
	commit: env.frontendVersion + env.branch,
	major: 1,
	minor: 0,
	patch: 0,
};

export function SaveProjectWindow(
	props: SaveProjectWindowProps & { id: string },
) {
	const dispatch = useAppDispatch();
	const logicsStatus = useAppSelector(selectFetchLogicsStatus);
	const editor = useAppSelector(selectEditor);

	const saveComputer = () => {
		if (logicsStatus.code !== "succeeded") {
			throw new Error("Logics not loaded");
		}

		const saveFormat: SaveFormat = {
			logicsCommitRef: logicsStatus.logics.commit,
			editor,
			saveVersion,
			idMap: getUniqueIdMap(),
		};

		const json = JSON.stringify(saveFormat);
		const compressed = Pako.deflate(json);

		function download(content: any, fileName: string, contentType: string) {
			let a = document.createElement("a");
			let file = new Blob([content], { type: contentType });
			a.href = URL.createObjectURL(file);
			a.download = fileName;
			a.click();
		}

		download(compressed, `${editor.projectName}.ppf`, "blob");
		dispatch(closeWindow(props.id));
	};

	return (
		<div className={css.content}>
			<div id="loadproject" className={css.content}>
				<div className={css.confirmButtonChunk}>
					<button className={css.confirmButton} onClick={saveComputer}>
						<FontAwesomeIcon icon={faComputer} /> Computer
					</button>
					<button
						className={css.confirmButton}
						onClick={() => {
							const windowSize = { x: 500, y: 200 };

							dispatch(
								createWindow({
									title: "Nome do arquivo",
									typeAndProps: {
										type: "filename",
										props: {},
									},
									position: {
										x: (window.innerWidth - windowSize.x) / 2,
										y: (window.innerHeight - windowSize.y) / 2,
									},
									size: windowSize,
								}),
							);
						}}
					>
						<FontAwesomeIcon icon={faMicrosoft} /> OneDrive
					</button>
				</div>
			</div>
		</div>
	);
}
